import React from 'react';
import { Grid, GridColumn, Container, Header } from 'semantic-ui-react';
import DashboardChecklist from './DashboardChecklist';
import ContactCard from '../shared/ContactCard';
import MyCompany from '../shared/MyCompany';
import InvestorOverview from './InvestorOverview';
import '../styles.scss';
import CumulativeMatchesOverTime from './CumulativeMatchesOverTime';

const InvestorDashboard: React.FC = () => {

    return (
        <div id="investor-dashboard" className="dashboard">
            <Container>
                <Grid stackable>
                    <GridColumn width={12} style={{ paddingBottom: '0' }}>
                        <Header as="h1">Dashboard</Header>
                    </GridColumn>
                    <GridColumn computer={8} tablet={12} mobile={16}>
                        <DashboardChecklist />
                        <InvestorOverview />
                        <CumulativeMatchesOverTime />
                    </GridColumn>
                    <GridColumn computer={4} tablet={12} mobile={16}>
                        <ContactCard />
                        <MyCompany />
                    </GridColumn>
                </Grid>
            </Container>
        </div>
    );
};

export default InvestorDashboard;